export default "__VITE_ASSET__d1e0d4cc__"